import { transformWrite } from "./encryption";
import { openUserCache } from "./openCache";

export const putData = async <Data>(rawData: Data, dbName: string, id: string, encryptionDisabled = true) => {
	const stringData = JSON.stringify(rawData);
	const encryptedData = encryptionDisabled ? stringData : await transformWrite(new TextEncoder().encode(stringData));

	const db = await openUserCache();
	const transaction = db.transaction([dbName], "readwrite");
	const store = transaction.objectStore(dbName);
	const request = store.put(encryptedData, id);

	(transaction as any).commit(); // todo
	return new Promise((resolve, reject) => {
		request.onerror = reject;
		request.onsuccess = resolve;
		transaction.onabort = reject;
	});
};
